var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bag-02"
  }, /*#__PURE__*/React.createElement("path", {
    id: "union-1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.07444 6.13569C7.48386 3.78619 9.53334 2 12 2C14.4667 2 16.5162 3.78619 16.9256 6.13569C18.7671 6.57403 20.2446 8.03565 20.6554 9.95235L21.9411 15.9524C22.608 19.0649 20.2353 22 17.0521 22H6.94795C3.76473 22 1.39197 19.0649 2.05894 15.9524L3.34466 9.95236C3.75538 8.03565 5.23292 6.57403 7.07444 6.13569ZM9.17071 6H14.8293C14.4175 4.83481 13.3062 4 12 4C10.6938 4 9.58255 4.83481 9.17071 6ZM8.23367 8C6.81906 8 5.59666 8.9882 5.30026 10.3714L4.01455 16.3714C3.61436 18.2389 5.03802 20 6.94795 20H17.0521C18.962 20 20.3856 18.2389 19.9855 16.3714L18.6997 10.3714C18.4033 8.9882 17.181 8 15.7663 8H8.23367Z",
    fill: "#121212"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrders);
export default __webpack_public_path__ + "static/media/orders.31504d6fdce84e63eeece19f9faf52be.svg";
export { ForwardRef as ReactComponent };